import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import {
  SupplierInventoryRequest,
  SupplierInventoryVehiclesRequest,
  UpdateStatusDeletedRequest
} from '@/main/models/request';
import {
  SupplierInventoryDataResponse,
  SupplierInventoryResponse,
  SupplierInventoryVehicleResponse,
  SupplierInventoryWarehousePriceResponse
} from '@/main/models/response';
import { PaginationResponse } from '@/main/models/common/paginationResponse';

export abstract class ISupplierInventoryApi {
  abstract getSearchGrid(
    request: SupplierInventoryRequest
  ): Promise<AxiosResponse<Result<SupplierInventoryResponse>>>;

  abstract changeStatusPartsCatalog(
    request: SupplierInventoryRequest
  ): Promise<AxiosResponse<Result<void>>>;

  abstract getInfoPart(
    request: SupplierInventoryRequest
  ): Promise<AxiosResponse<Result<SupplierInventoryDataResponse>>>;

  abstract getVehiclesInventory(
    request: SupplierInventoryVehiclesRequest
  ): Promise<
    AxiosResponse<PaginationResponse<SupplierInventoryVehicleResponse>>
  >;

  abstract updateStatusDeleted(
    request: UpdateStatusDeletedRequest
  ): Promise<AxiosResponse<Result<boolean>>>;
  abstract getWarehousePartPrice(
    guidSupplierInventoryWarehouse: string
  ): Promise<AxiosResponse<Result<SupplierInventoryWarehousePriceResponse[]>>>;
}

